import Calendar from '@app/components/Calendar'
import {
  CalendarLegend,
  CalendarLegendEntry,
} from '@app/components/CalendarLegend'
import { ICurrentUserState } from '@app/store/modules/account'
import { convertToWebcalUrl } from '@app/utils/calendar'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
// import { Form, FormGroup, Input, Label } from 'reactstrap'
import {
  actionCreators,
  IDueDiligenceCalendarState,
} from '../modules/dueDiligenceCalendar'

type DueDiligenceCalendarProps = IDueDiligenceCalendarState &
  typeof actionCreators &
  ICurrentUserState

export class DueDiligenceCalendar extends React.PureComponent<
  DueDiligenceCalendarProps
> {
  constructor(props: DueDiligenceCalendarProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title='Due Diligence Calendar'>
        <div className='h-100 d-flex flex-column p-3'>
          <div className='d-flex justify-content-between'>
            <div>
              <h4>My Due Diligence</h4>
            </div>
            {/* Currently the DueDiligence calendar does not support the All scope
            {this.props.user && this.props.user.permissions.isAdmin && (
              <Form inline>
                <FormGroup>
                  <Label className='mr-2'>View</Label>
                  <Input
                    bsSize='sm'
                    onChange={this._onScopeChanged}
                    type='select'
                    value={this.props.scope}>
                    <option value={DueDiligenceCalendarScope.All}>All assignments</option>
                    <option value={DueDiligenceCalendarScope.Mine}>Only my assignments</option>
                  </Input>
                </FormGroup>
              </Form>
            )}
            */}
          </div>
          <Calendar
            containerClassName='flex-grow-1 my-2'
            events={this.props.events}
            onDateRangeChanged={this.props.loadEvents}
          />
          <div className='d-flex justify-content-between'>
            <div>
              <a
                href={convertToWebcalUrl(this.props.downloadUrl)}
                target='_blank'
                rel='noreferrer'
              >
                Sync with your calendar
              </a>
            </div>
            <div>
              <CalendarLegend>
                <CalendarLegendEntry
                  entryKey='event-assignment'
                  entryDescription='Assigned to me'
                />
              </CalendarLegend>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  // private _onScopeChanged(event: React.ChangeEvent<HTMLInputElement>) {
  //   this.props.setScope(event.target.value as DueDiligenceCalendarScope)
  //   this.props.loadEvents(this.props.startTime, this.props.endTime)
  // }
}
